<template>
  <section
    v-if="shopifyData.checkSection == 'true'"
    :id="'blog-hero-' + shopifyData.nameOfPage"
    :class="shopifyData.nameOfPage"
    class="banner_sec blog-hero"
    :style="{ backgroundColor: backgroundColor }"
  >
    <!-- Banner Content -->
    <div class="banner_content">
      <div class="banner_content">
        <h1
          class="banner_main_heading"
          :style="{ fontSize: fontSize }"
          v-html="shopifyData.heroHeading"
        />
        <div class="banner_img t-center">
          <img
            v-lazy="shopifyData.heroImgDesktop.src"
            class="desktop_img"
            :style="{ width: imgWidthDesktop }"
            :src-placeholder="shopifyData.heroImgDesktop.placeholder"
            :alt="shopifyData.heroImgDesktop.alt"
          />
          <img
            v-lazy="shopifyData.heroImgMobile.src"
            class="mobile_img"
            :src-placeholder="shopifyData.heroImgMobile.placeholder"
            :alt="shopifyData.heroImgMobile.alt"
          />
        </div>
      </div>
    </div>
    <!-- gal -->
  </section>
</template>
<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  data() {
    if (this.shopifyData.mode == 'true') {
      document.body.classList.add('landscape');
    }
  },
  computed: {
    backgroundColor() {
      return window.innerWidth <= 768
        ? this.shopifyData.sectionColorMob
        : this.shopifyData.sectionColorDesktop;
    },
    fontSize() {
      return window.innerWidth <= 768
        ? this.shopifyData.heroHeadingSizeMobile + 'px'
        : this.shopifyData.heroHeadingSize + 'px';
    },
    imgWidthDesktop() {
      return window.innerWidth <= 768 ? '100%' : this.shopifyData.heroImgWidthDesktop + 'px';
    },
  },
};
</script>
<style>
body.blog.blog\.i-am .banner_img .desktop_img {
  max-width: 909px;
  width: 100%;
}
</style>
<style scoped>
.banner_main_heading {
  transform: translateY(35%);
  font-weight: 700;
  font-size: 160px;
  line-height: 1.21;
  text-align: center;
  color: #000000;
}
.mobile_img {
  display: none;
}

/* Responsive Breakpoints */
@media screen and (max-width: 767px) {
  .banner_main_heading {
    font-size: 72px;
    line-height: 87px;
  }
  .mobile_img {
    display: block;
    margin: 0 auto;
  }
  .desktop_img {
    display: none;
  }
}
</style>
